export default "__VITE_ASSET__Bigv15mO__"